/**
 * @description : 404 Page
 * @author : SAR TECH EASY
 * @date : 19-04-2023
 * */

/* Import Components and Functions Here */
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

function Page404(props) {
  const navigate = useNavigate();
  const title = props.title || 'Page Not Found';
  const description = props.description || 'Page Not Found';
  const showBackOffice =
    props.showBackOffice !== undefined ? props.showBackOffice : true;
  const companyName =
    props.companyName ||
    process.env.COMPANY_NAME ||
    process.env.COMP_NAME ||
    'Company';

  const fullTitle = showBackOffice
    ? `${title} | Back Office | ${companyName}`
    : `${title} | ${companyName}`;

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
      <MetaTags>
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
      </MetaTags>
      <Container fluid>
        <Row
          className="d-flex justify-content-center align-items-center errorMsg"
          style={{ height: '542px' }}
        >
          <Col md="4" className="d-flex flex-column text-center">
            <h1>404</h1>
            <h2>Page not found</h2>
            <p>The page you are looking for doesn't exist or has been moved</p>
            <div className="mt-3">
              <Button variant="primary" onClick={handleGoHome} className="me-2">
                Go Home
              </Button>
              <Button variant="outline-secondary" onClick={() => navigate(-1)}>
                Go Back
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Page404;
